export class LocalAgentFinder {
    private autoPrompt: boolean;
    public static cssClass: string = 'agent-location-trigger';

    constructor(private rootElement: HTMLButtonElement) {
        this.autoPrompt = rootElement.dataset.autoPrompt === 'True';
        this.rootElement.addEventListener('click', this.promptLocation);
        if (this.autoPrompt)
            this.promptLocation();
    }

    public promptLocation = (): void => {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(this.onLocationObtained);
        } else {
            console.log('Browser does not support geolocation.');
            this.onError();
        }
    };

    private onError = (): boolean => this.rootElement.disabled = true;

    private onLocationObtained = (position: GeolocationPosition): void => this.navigateToResults(position.coords);

    public navigateToResults = (coordinates: GeolocationCoordinates): void => {
        const form = document.createElement('form');
        form.method = 'post';
        form.action = this.rootElement.dataset.submitUrl;
        const addInput = (name: string, value: any) => {
            const input = document.createElement('input');
            input.name = name;
            input.value = value;
            form.appendChild(input);
        };
        addInput('Latitude', coordinates.latitude);
        addInput('Longitude', coordinates.longitude);

        document.body.appendChild(form);
        form.submit();
    }
}